import { create, getById, getAll, getBySingleQuery } from '../utils/dbUtils';
import { isBooleanTrue, isListEmpty, isNotNullOrUndefined, isObjectNotEmpty, isStringEmpty, isStringNotEmpty, isStringNotEmptyOrZeroLength } from "../utils/objectUtils";
import { collection, getCountFromServer, getDocs, limit, orderBy, query, where } from 'firebase/firestore';
import { db } from '../firebase';

class AuditLog {
    static collectionName = 'auditLogs';

    type = "";

    state = null;

    metaData = {}; // array of auditLog metadata

    action = ""; // description of the action triggering the log

    testMode = false;

    constructor(auditLog) {
        if (isObjectNotEmpty(auditLog)) {
            if (isStringNotEmpty(auditLog.type)) { this.type = auditLog.type; }

            if (isNotNullOrUndefined(auditLog.state)) { this.state = auditLog.state; }

            if (isNotNullOrUndefined(auditLog.metaData)) { this.metaData = auditLog.metaData; }

            if (isNotNullOrUndefined(auditLog.action)) { this.action = auditLog.action; }

            if (isBooleanTrue(auditLog.testMode)) { this.testMode = true; }
        }
    }

    toDto = () => {
        return {
            type: this.type,
            state: this.state,
            metaData: this.metaData,
            loggedAt: this.loggedAt,
            action: this.action,
            testMode: this.testMode
        };
    }

    isValid = () => {
        if (isStringEmpty(this.type)) {
            throw new Error('auditLog type is required.');
        }

        if (isListEmpty(this.state)) {
            throw new Error('auditLog state is required.');
        }

        return true;
    }

    create = async () => {
        if (this.isValid()) {
            return await create(AuditLog.collectionName, this.toDto());
        }
    }

    static getById = async (id) => {
        if (isStringNotEmpty(id)) {
            return await getById(AuditLog.collectionName, id);
        } else {
            throw new Error("id is required.");
        }
    }

    static getAll = async () => {
        return await getAll(AuditLog.collectionName);
    }

    static getByField = async (fieldName, fieldValue, comparer = '==') => {
        return await getBySingleQuery(AuditLog.collectionName, fieldName, fieldValue, comparer);
    }

    static search = async (searchCriteria) => {
        let { name, tag } = searchCriteria;

        let queryConstraints = [];

        if (isStringNotEmptyOrZeroLength(name)) {
            queryConstraints.push(where('name', '==', name));
        }

        if (isStringNotEmptyOrZeroLength(tag)) {
            queryConstraints.push(where('tags', 'array-contains', tag));
        }

        queryConstraints.push(orderBy('createdAt', 'asc'));
        queryConstraints.push(orderBy('__name__', 'asc'));

        return await this.getByQueryConstraints(queryConstraints);
    }

    static getCount = async (queryParameters) => {
        const { testMode, name, tag } = queryParameters;

        let queryConstraints = [];

        if (isNotNullOrUndefined(testMode)) {
            queryConstraints.push(where('testMode', '==', isBooleanTrue(testMode)));
        }

        if (isStringNotEmptyOrZeroLength(name)) {
            queryConstraints.push(where('name', '==', name));
        }

        if (isStringNotEmptyOrZeroLength(tag)) {
            queryConstraints.push(where('tags', 'array-contains', tag));
        }

        let q = query(collection(db, AuditLog.collectionName), ...queryConstraints);

        const snapShot = await getCountFromServer(q);

        return snapShot.data().count;
    }

    static getPaginated = async (queryParameters, pageSize = 25, orderByField = 'createdAt') => {
        const { testMode, name, tag } = queryParameters;

        let queryConstraints = [];

        if (isNotNullOrUndefined(testMode)) {
            queryConstraints.push(where('testMode', '==', isBooleanTrue(testMode)));
        }

        if (isStringNotEmptyOrZeroLength(name)) {
            queryConstraints.push(where('name', '==', name));
        }

        if (isStringNotEmptyOrZeroLength(tag)) {
            queryConstraints.push(where('tags', 'array-contains', tag));
        }

        const q = query(collection(db, AuditLog.collectionName), ...queryConstraints, orderBy(orderByField, 'asc'), orderBy('__name__', 'asc'), limit(pageSize));


        let snapshot = await getDocs(q);
        return snapshot.docs.map((doc) => {
            return {
                id: doc.id,
                ...doc.data()
            };
        });
    }

    static get = async (queryParameters) => {
        let allRecords = [];
        try {
            let next = null;

            let totalCount = await AuditLog.getCount(queryParameters);
            let totalPages = Math.ceil(totalCount / 10000.0);

            let pages = [];
            for (let i = 0; i < totalPages; i++) {
                pages.push(i + 1);
            }
            for (const page of pages) {

                let list = await AuditLog.getPaginated(queryParameters, 10000, 'createdAt');

                allRecords = [...allRecords, ...list];

                next = list[list.length - 1];
            }
        } catch (error) {
            console.log(error);
        }

        return allRecords;
    }
};

export default AuditLog;